"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _validator = _interopRequireDefault(require("validator"));

var _require = require('@sportheroes/sonic-constants'),
    PASSWORD_COMPLEXITY = _require.PASSWORD_COMPLEXITY;

var VALIDATOR_OPTIONS = {
  minLength: PASSWORD_COMPLEXITY.MIN_LENGTH,
  minUppercase: PASSWORD_COMPLEXITY.MIN_UPPERCASE,
  minLowercase: PASSWORD_COMPLEXITY.MIN_LOWERCASE,
  minNumbers: PASSWORD_COMPLEXITY.MIN_NUMBERS,
  minSymbols: PASSWORD_COMPLEXITY.MIN_SYMBOLS
};

var isPasswordValid = function isPasswordValid(password) {
  return !!(password && password.length > 0 && _validator["default"].isStrongPassword(password, VALIDATOR_OPTIONS));
};

var _default = isPasswordValid;
exports["default"] = _default;
//# sourceMappingURL=isPasswordValid.js.map